module.exports = __webpack_public_path__ + "static/early_cb-ee99c5fcb6b1764f78fc34eeeade0642.png";